import { useContext } from 'react'
import { TOGGLE_BOOK_TABLE_MODAL } from '../../reducer/actions/userActions'
import { GlobalContext } from '../../reducer/context'

const MRPNight = () => {
    const { dispatchAuth } = useContext(GlobalContext);
    
    return (
        <div className='mrp-night'>
            <div className='col-xl-3 col-lg-4 col-md-6 col-sm-8 col-xs-12 h-100' style={{ flex: 1 }}>
                <div className='mrp_Details h-100 position-relative'>
                    <div className='mrp_Details-box bg-white shadow-sm'>
                        <div className='position-absolute px-3 pt-3' style={{ top: 0, left: 0, right: 0, paddingBottom: 10 }}>
                            <div className='img-box border'>
                                <img
                                    src={"./img/mrp.jpg"}
                                    alt="mrp"
                                    wrapperClassName="image-holder w-100"
                                    style={{ height: "50%" }}

                                />
                            </div>
                            <div className='row gy mt-3 mx-0'>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/100-Piper.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>100-Piper</span>
                                            <span className='item-price'>₹1300</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/100-Piper-12.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>100 Pipers 12 Y/O</span>
                                            <span className='item-price'>₹1600</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Black-Dog-centenary.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Black Dog centenary</span>
                                            <span className='item-price'>₹1300</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Black-Dog-Deluxe.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Black Dog Deluxe</span>
                                            <span className='item-price'>₹1600</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Ballentines.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Ballentines</span>
                                            <span className='item-price'>₹1500</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Jameson.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Jameson</span>
                                            <span className='item-price'>₹1800</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Red-label.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Red label</span>
                                            <span className='item-price'>₹1500</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Black-Label.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Black Label</span>
                                            <span className='item-price'>₹2500</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Glenlivit-12.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Glenlivit 12Y/O</span>
                                            <span className='item-price'>₹4000</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Glenfiddich-12.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Glenfiddich 12 Y/O</span>
                                            <span className='item-price'>₹4000</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Absloute.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Absloute</span>
                                            <span className='item-price'>₹1500</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Grey-Goose.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Grey Goose</span>
                                            <span className='item-price'>₹3000</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Bombay-Gin.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Bombay Gin</span>
                                            <span className='item-price'>₹2000</span>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div className='item-box' onClick={() => dispatchAuth({ type: TOGGLE_BOOK_TABLE_MODAL })}>
                                        <span className='pack'>25 peg</span>
                                        <div className='img-box'>
                                            <img
                                                src={"./img/MRP-Bottles/Tanqueray.jpg"}
                                                alt="mrp"
                                                wrapperClassName="image-holder"
                                            />
                                        </div>
                                        <div className='item-content'>
                                            <span className='item-name'>Tanqueray</span>
                                            <span className='item-price'>₹2000</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MRPNight